import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function VmcDoubleFluxPage() {
  const travail = getTravailStub('vmc-double-flux');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
